import { EnumAyaEventType } from '../enums/aya-event-type.enum';
import { EnumConversationState } from '../enums/conversation-state.enum';

export const USER_STREAM_PROTOCOL = 'aya.v2';

/** O canal do usuário identifica a conversa; não há run nem sessão aqui. */
export interface IUserStreamEnvelope {
  type: EnumAyaEventType;
  conversationId: string;
  seq: number;
  payload: IUserStreamPayload;
}

export interface IUserStreamPayload {
  state?: EnumConversationState;
  title?: string | null;
  createdAt?: string;
}

/**
 * O `id:` do SSE é cursor opaco do canal — nunca derivado de `seq`.
 *
 * `envelope` nulo é a abertura da conexão: o canal pode ficar em silêncio por
 * muito tempo, e sem esse aviso quem consome não distingue conectado de morto.
 */
export interface IUserStreamEvent {
  envelope: IUserStreamEnvelope | null;
  cursor: string | null;
}

/**
 * Controle enviado quando a retenção expira depois do HTTP 200. Não tem `id:`,
 * `conversation_id` nem `seq`: o consumidor recarrega a lista e reassina com o
 * cursor do snapshot novo.
 */
export interface IUserStreamReset {
  reason: string;
  historyRequired: boolean;
}

export const USER_STREAM_EVENTS: ReadonlyArray<EnumAyaEventType> = [
  EnumAyaEventType.CONVERSATION_CREATED,
  EnumAyaEventType.CONVERSATION_TITLE_UPDATED,
  EnumAyaEventType.CONVERSATION_STATE_CHANGED,
  EnumAyaEventType.CONVERSATION_DELETED
];
